import get from './get/'
import set from './set/'
import update from './update/'
import remove from './remove/'
import { setUser, unsetUser } from './user-setters/'
import Client, { config } from './client/'
import initFirebase from './init-firebase/'
import me from './me/'
import upload from './upload/'
import now from './now/'

let client = null
export const getClient = () => client

const api = {
  init: ({ project, firebaseConfig, stripeKey }) => {
    client = Client({ project, stripeKey })
    initFirebase({ firebaseConfig })
  },
  get,
  set,
  update,
  remove,
  setUser,
  unsetUser,
  me,
  upload,
  config,
  now
}

export default api
